import { getDefaultEnabledModules } from './tenantModules';

export const DEFAULT_TENANT_TERMINOLOGY = Object.freeze({
  people: Object.freeze({
    employee: 'Employee',
    employees: 'Employees',
    manager: 'Manager',
    managers: 'Managers'
  }),
  organization: Object.freeze({
    location: 'Location',
    locations: 'Locations',
    department: 'Department',
    departments: 'Departments'
  }),
  workspace: Object.freeze({
    workforce: 'Workforce',
    managerNotes: 'Manager Notes',
    goals: 'Goals',
    scorecards: 'Scorecards',
    requests: 'Requests'
  })
});

export const DEFAULT_TENANT_CONFIG = Object.freeze({
  companyId: null,
  companyDisplayName: '',
  industryKey: 'general_operations',
  logoUrl: null,
  logoStorageKey: null,
  modulesConfigured: false,
  enabledModules: Object.freeze(getDefaultEnabledModules()),
  terminology: DEFAULT_TENANT_TERMINOLOGY,
  createdAt: null,
  updatedAt: null
});

export function mergeTenantTerminology(terminology = {}) {
  return {
    people: {
      ...DEFAULT_TENANT_TERMINOLOGY.people,
      ...((terminology && terminology.people) || {})
    },
    organization: {
      ...DEFAULT_TENANT_TERMINOLOGY.organization,
      ...((terminology && terminology.organization) || {})
    },
    workspace: {
      ...DEFAULT_TENANT_TERMINOLOGY.workspace,
      ...((terminology && terminology.workspace) || {})
    }
  };
}

export function buildDefaultTenantConfig(overrides = {}) {
  return {
    ...DEFAULT_TENANT_CONFIG,
    ...overrides,
    modulesConfigured: overrides.modulesConfigured === true,
    enabledModules: Array.isArray(overrides.enabledModules)
      ? [...overrides.enabledModules]
      : [...DEFAULT_TENANT_CONFIG.enabledModules],
    terminology: mergeTenantTerminology(overrides.terminology || DEFAULT_TENANT_CONFIG.terminology)
  };
}

export function getTerminologyValue(terminology, path, fallback = '') {
  const segments = Array.isArray(path) ? path : String(path || '').split('.').filter(Boolean);
  let current = mergeTenantTerminology(terminology);
  for (const segment of segments) {
    if (!current || typeof current !== 'object') return fallback;
    current = current[segment];
  }
  return typeof current === 'string' && current.trim() ? current : fallback;
}
